import {
    PlusOutlined,
    UploadOutlined
} from "@ant-design/icons";

import { Col, Divider, Flex, Modal, Row, Space, Switch, Upload } from "antd";
import { Collapse } from "antd/lib";
import { Button } from "components/elements";
import styles from "components/elements/Modal/Modal.module.css";
import { DatePicker, Input, Select, InputNumber } from "components/form";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EXPENSE_SCHEMAS, EXPENSE_VALIDATE } from "../schemas/ExpenseSchema";

const { Panel } = Collapse;

function formatDate(dateString, pattern = "DD-MM-YYYY") {
    console.log("dateString", dateString);
    if (!dateString) return;
    const date = dayjs(dateString, pattern);
    return date.format("DD-MM-YYYY");
}

function ExpenseModal({
    isModalOpen = false,
    initialValues = {},
    onCancel = () => { },
    handleOk = () => { },
    onSubmit = () => { },
    onEdit = () => { },
    submit = "SAVE",
    back = "BACK",
    options = []

}) {
    const { t } = useTranslation()
    const [isActive, setIsActive] = useState(initialValues?.foreignCurrencyStatus || false)
    return (
        <Modal
            styles={{
                body: {
                    height: "70vh",
                    overflowY: "scroll"
                }
            }}
            footer={null}
            title={initialValues?.txnExpenseRequestId ? t("common.edit") : t("common.create")}
            open={isModalOpen}

            onOk={handleOk}
            onCancel={() => {
                const cancelBtn = document.getElementById(
                    "year_accumulate_cancelBtn"
                );
                if (cancelBtn) {
                    cancelBtn.click();
                } else {
                    onCancel();
                }
                setIsActive(!isActive)
            }}
            closable={false}
            maskClosable={false}
        >
            <Formik
                enableReinitialize
                initialValues={{
                    ...EXPENSE_SCHEMAS,
                    ...initialValues,
                    expenseDate: dayjs(initialValues?.expenseDate),
                    isActive: initialValues?.foreignCurrencyStatus === "Y" ? isActive : !isActive,
                    foreignCurrencyId: initialValues?.foreignCurrencyId
                }}
                validationSchema={EXPENSE_VALIDATE}
                onSubmit={(values) => {
                    const modifiedValues = {
                        ...values,
                        expenseDate: dayjs(values?.expenseDate).format("YYYY-MM-DD"),
                        foreignCurrencyStatus: isActive ? "Y" : "N",
                    }
                    onSubmit(modifiedValues, onCancel)
                }}
            >
                {({ values = {}, setFieldValue = () => { }, resetForm = () => { } }) => {
                    console.log("initialModal ", values);
                    return (
                        <Form>
                            <Space
                                className={styles.container}
                                size={24}
                                direction="vertical">
                                <Divider />
                                <Row>
                                    <Col span={24}>
                                        <Input
                                            name="subject"
                                            placeholder={t('expense.subject')}
                                            label={t('expense.subject')}
                                            size="large"
                                            required
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <DatePicker
                                            format={formatDate()}
                                            placeholder="DD / MM / YYYY *"
                                            name="expenseDate"
                                            required
                                            label={t('expense.expense-date')}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <Input
                                            name="description"
                                            label={t('expense.description')}
                                            placeholder={t("expense.description")}
                                            size="large"
                                            type="textarea"
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11}>
                                        <Upload
                                            name="attachment"
                                            action={null}
                                            beforeUpload={(file) => {

                                            }}
                                            onRemove={(file) => {

                                            }}
                                        // fileList={attachments?.map((a) => a?.content)}
                                        >
                                            <Button htmlType="button" type="default" style={{ width: "100%" }}>
                                                <UploadOutlined />
                                                {/* {loading ? <LoadingOutlined /> : <UploadOutlined />} */}
                                                {t("common.upload")}
                                            </Button>
                                        </Upload>
                                    </Col>
                                    <Col span={2} />
                                    <Col span={11}></Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <label htmlFor="">{t("expense.currencyHeader")}</label>
                                    </Col>
                                    <Col span={12} style={{ textAlign: "end" }}>
                                        <Switch
                                            checked={isActive}
                                            onChange={() => {
                                                setIsActive(!isActive)
                                                setFieldValue("foreignCurrencyId", null)
                                                setFieldValue("currencyRate", null)
                                            }}
                                            name="foreignCurrencyStatus"
                                            size="50"
                                        />
                                    </Col>
                                    {isActive && (
                                        <Flex justify='center' align='center' gap={50} style={{
                                            paddingLeft: 30
                                        }}>
                                            <Flex style={{
                                                width: "150px"
                                            }}>

                                                <Select
                                                    name="foreignCurrencyId"
                                                    label={t("expense.currency")}
                                                    placeholder={t('please-select')}
                                                    size="large"
                                                    options={options} />
                                            </Flex>
                                            <Flex>
                                                <Input
                                                    name="currencyRate"
                                                    label={t("expense.exchange")}
                                                    size="large"
                                                />
                                            </Flex>
                                        </Flex>
                                    )}
                                </Row>
                                <Row>
                                    <Col span={10}><label >{t("expense.expense-detail.header")}</label></Col>
                                    <Col span={14}></Col>
                                </Row>

                                <Collapse
                                    bordered={false}
                                    // defaultActiveKey={['1']}
                                    expandIcon={() => null}

                                >

                                    <Panel header={<span><PlusOutlined /> {t("expense.expense-detail.fule")}</span>} forceRender={values?.fuelExpenseStatus === "Y"}
                                        style={{
                                            backgroundColor: values?.fuelExpenseStatus === "Y" ? "lightblue" : "transparent"
                                        }}>
                                        <Row>
                                            <Col span={11}><Input name='startMiles' label={t("expense.expense-detail.miles-start")} /></Col>
                                            <Col span={2}></Col>
                                            <Col span={11}><Input name='endMiles' label={t("expense.expense-detail.miles-end")} /></Col>
                                        </Row>
                                        <Row style={{ marginTop: "10px", marginBottom: "10px" }}>
                                            <Col span={11}><Input name='distance' label={t("expense.expense-detail.distance")} /></Col>
                                            <Col span={2}></Col>
                                            <Col span={11}><Input name='fuelExpense' label={t("expense.expense-detail.fule")} /></Col>
                                        </Row>
                                        <Row justify='end' style={{ gap: 8 }}>

                                            {values?.fuelExpenseStatus === "Y" && (
                                                <Button type="primary" onClick={() => {
                                                    setFieldValue("fuelExpenseStatus", "N")
                                                    setFieldValue("startMiles", null)
                                                    setFieldValue("endMiles", null)
                                                    setFieldValue("distance", null)
                                                    setFieldValue("fuelExpense", null)
                                                }}>
                                                    {t("common.deleteClear")}
                                                </Button>
                                            )}
                                            <Button type="primary" onClick={() => setFieldValue("fuelExpenseStatus", "Y")}>
                                                {t("common.add")}
                                            </Button>
                                        </Row>
                                    </Panel>
                                    <Panel header={<span><PlusOutlined /> {t("expense.expense-detail.accommodation")}</span>} forceRender={values?.accommondationStatus === "Y"}
                                        style={{
                                            backgroundColor: values?.accommondationStatus === "Y" ? "lightblue" : "transparent"
                                        }}>
                                        <Row>
                                            <Col span={11}><Input name='totalNights' label={t("expense.expense-detail.nights")} /></Col>
                                            <Col span={2}></Col>
                                            <Col span={11}><Input name='accommodationExpense' label={t("expense.expense-detail.total-expense")} /></Col>
                                        </Row>
                                        <Row justify='end' style={{ marginTop: "10px", gap: 8 }}>
                                            {values?.accommondationStatus === "Y" && (
                                                <Button type="primary" onClick={() => setFieldValue("accommondationStatus", "N")}>
                                                    {t("common.deleteClear")}
                                                </Button>
                                            )}
                                            <Button type="primary" onClick={() => setFieldValue("accommondationStatus", "Y")}>
                                                {t("common.add")}
                                            </Button>

                                        </Row>
                                    </Panel>
                                    <Panel header={<span><PlusOutlined /> {t("expense.expense-detail.meeting")}</span>} forceRender={values?.meetingExpenseStatus === "Y"}
                                        style={{
                                            backgroundColor: values?.meetingExpenseStatus === "Y" ? "lightblue" : "transparent"
                                        }}>
                                        <Row>
                                            <Col span={11}><Input name='numberOfPersonInMeeting' label={t("expense.expense-detail.participants")} /></Col>
                                            <Col span={2}></Col>
                                            <Col span={11}><Input name='meetingExpense' label={t("expense.expense-detail.meeting")} /></Col>
                                        </Row>
                                        <Row justify='end' style={{ marginTop: "10px", gap: 8 }}>

                                            {values?.meetingExpenseStatus === "Y" && (
                                                <Button type="primary" onClick={() => setFieldValue("meetingExpenseStatus", "N")}>
                                                    {t("common.deleteClear")}
                                                </Button>
                                            )}
                                            <Button type="primary" onClick={() => setFieldValue("meetingExpenseStatus", "Y")}>
                                                {t("common.add")}
                                            </Button>
                                        </Row>
                                    </Panel>
                                    <Panel header={<span><PlusOutlined /> {t("expense.expense-detail.travel")}</span>}
                                        forceRender={values?.travelExpenseStatus === "Y"}
                                        style={{
                                            backgroundColor: values?.travelExpenseStatus === "Y" ? "lightblue" : "transparent"
                                        }}>
                                        <Row>
                                            <Col span={24}><Input name='parkingExpense' label={t("expense.expense-detail.parking")} /></Col>

                                        </Row>
                                        <Row style={{ marginTop: "10px", marginBottom: "10px" }}>
                                            <Col span={11}><Input name='travelExpense' label={t("expense.expense-detail.travel")} /></Col>
                                            <Col span={2}></Col>
                                            <Col span={11}><Input name='tollFreeExpense' label={t("expense.expense-detail.toll-fee")} /></Col>
                                        </Row>
                                        <Row justify='end' onClick={() => setFieldValue("travelExpenseStatus", "Y")}>
                                            <Button type="primary">
                                                {t("common.add")}
                                            </Button>
                                        </Row>
                                    </Panel>
                                    <Panel header={<span><PlusOutlined /> {t("expense.expense-detail.entertainment")}</span>}
                                        forceRender={values?.entertainmentExpenseStatus === "Y"}
                                        style={{
                                            backgroundColor: values?.entertainmentExpenseStatus === "Y" ? "lightblue" : "transparent"
                                        }}>
                                        <Row>
                                            <Col span={11}><Input name='numberOfPersonInEntertainment' label={t("expense.expense-detail.participants")} /></Col>
                                            <Col span={2}></Col>
                                            <Col span={11}><Input name='entertainmentExpense' label={t("expense.expense-detail.entertainment")} /></Col>
                                        </Row>
                                        <Row justify='end' style={{ marginTop: "10px" }}>
                                            <Button type="primary" onClick={() => setFieldValue("entertainmentExpenseStatus", "Y")}>
                                                {t("common.add")}
                                            </Button>
                                        </Row>
                                    </Panel>
                                    <Panel header={<span><PlusOutlined /> {t("expense.expense-detail.staff-allowance")}</span>}
                                        forceRender={values?.staffAllowanceStatus === "Y"}
                                        style={{
                                            backgroundColor: values?.staffAllowanceStatus === "Y" ? "lightblue" : "transparent"
                                        }}>
                                        <Row>
                                            <Col span={24}><Input name='staffAllowanceExpense' label={t("expense.expense-detail.staff-allowance")} /></Col>
                                        </Row>
                                        <Row justify='end' style={{ marginTop: "10px" }}>
                                            <Button type="primary" onClick={() => setFieldValue("staffAllowanceStatus", "Y")}>
                                                {t("common.add")}
                                            </Button>
                                        </Row>
                                    </Panel>
                                    <Panel header={<sapn><PlusOutlined /> {t("expense.expense-detail.training")}</sapn>}
                                        forceRender={values?.trainingStatus === "Y"}
                                        style={{
                                            backgroundColor: values?.trainingStatus === "Y" ? "lightblue" : "transparent"
                                        }}>
                                        <Row>
                                            <Col span={24}><Input name='trainingTitle' label={t("expense.expense-detail.training-title")} /></Col>
                                        </Row>
                                        <Row style={{ marginTop: "10px" }}>
                                            <Col span={11}>
                                                <Input name='trainingHours' label={t("expense.expense-detail.hours")} />
                                            </Col>

                                            <Col span={2} />
                                            <Col span={11}>
                                                <InputNumber name='trainingMinutes' label={t("expense.expense-detail.minutes")}
                                                    controls={false}
                                                    max={59}
                                                    precision={0}
                                                />
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: "10px" }}>
                                            <Col span={11}>
                                                <Input name='numberOfParticipants' label={t("expense.expense-detail.participants")} />
                                            </Col>
                                            <Col span={2} />
                                            <Col span={11}>
                                                <Input name='trainingExpense' label={t("expense.expense-detail.total-expense")} />
                                            </Col>
                                        </Row>
                                        <Row justify='end' style={{ marginTop: "10px" }}>
                                            <Button type="primary" onClick={() => setFieldValue("trainingStatus", "Y")}>
                                                {t("common.add")}
                                            </Button>
                                        </Row>
                                    </Panel>
                                    <Panel header={<span><PlusOutlined /> {t("expense.expense-detail.others")}</span>}
                                        forceRender={values?.othersStatus === "Y"}
                                        style={{
                                            backgroundColor: values?.othersStatus === "Y" ? "lightblue" : "transparent"
                                        }}>
                                        <Row>
                                            <Col span={11}><Input name='otherDiscription' label={t("expense.description")} /></Col>
                                            <Col span={2} />
                                            <Col span={11}><Input name='otherExpense' label={t("expense.expense-detail.others")} /></Col>
                                        </Row>
                                        <Row justify='end' style={{ marginTop: "10px" }}>
                                            <Button
                                                onClick={() => setFieldValue("othersStatus", "Y")}
                                                disabled={values?.otherExpense == null ||
                                                    values?.otherExpense == ''}
                                                type="primary">
                                                {t("common.add")}
                                            </Button>
                                        </Row>
                                    </Panel>
                                </Collapse>
                                <Row>
                                    <Col span={16} />
                                    <Col span={8}>
                                        <Space direction="horizontal" size={12}>
                                            <Button
                                                id="organization__cancelBtn"
                                                key="back"
                                                onClick={() => {
                                                    onCancel();
                                                    resetForm();
                                                    setIsActive(!isActive)
                                                }}
                                                className={styles.cancelContainer}
                                            >
                                                {t("common.cancel").toUpperCase()}
                                            </Button>
                                            <Button
                                                htmlType="submit"
                                                type="primary"
                                                className={styles.cancelSave}
                                            >
                                                {t("common.save").toUpperCase()}
                                            </Button>
                                        </Space>
                                    </Col>
                                </Row>

                            </Space>

                        </Form>
                    )
                }}
            </Formik>

        </Modal >
    )
}
export default ExpenseModal